<template>
  <!-- A marca oficial e verde+vermelha sobre branco; o cabecalho do dashboard e
       o login usam fundo verde-escuro. A pilula branca preserva as cores da
       marca e da o mesmo resultado nos dois lugares. -->
  <span class="luck-logo">
    <img
      class="luck-logo-img"
      src="@/assets/luck-logo.png"
      alt="Luck Receptivo"
    />
  </span>
</template>

<script>
export default {
  name: "LuckLogo",
};
</script>

<style src="./styles.scss" scoped lang="scss" />
